import styled from 'styled-components';

import { useIsDesktop, useIsDesktopOrTablet } from '../../../styles/media-queries';
import BaseText, { type TextProps } from '../base-text';
import type { TextVariantProps } from './type';

const SM = ({ children, ...props }: TextVariantProps) => (
  <BaseText {...props} fontSize={16} fontWeight={700} lineHeight={1.1875}>
    {children}
  </BaseText>
);

const MD = ({ children, ...props }: TextVariantProps) => (
  <BaseText {...props} fontSize={20} fontWeight={800} lineHeight={1.15}>
    {children}
  </BaseText>
);

const LG = ({ children, ...props }: TextVariantProps) => (
  <BaseText {...props} fontSize={26} fontWeight={900} lineHeight={1.17}>
    {children}
  </BaseText>
);

const XL = ({ children, ...props }: TextVariantProps) => (
  <BaseText {...props} fontSize={32} fontWeight={900} lineHeight={0.92}>
    {children}
  </BaseText>
);

const XXL = ({ children, ...props }: TextVariantProps) => (
  <BaseText {...props} fontSize={38} fontWeight={900} lineHeight={0.92}>
    {children}
  </BaseText>
);

const XXXL = ({ children, ...props }: TextVariantProps) => {
  const isDesktop = useIsDesktop();

  return (
    <BaseText {...props} fontSize={isDesktop ? 58 : 48} fontWeight={900} lineHeight={1.04}>
      {children}
    </BaseText>
  );
};

const Title = (props: TextVariantProps) => <MD {...props} />;

Title.SM = SM;
Title.MD = MD;
Title.LG = LG;
Title.XL = XL;
Title.XXL = XXL;
Title.XXXL = XXXL;

export type TitleSize = keyof typeof Title;

const StyledMobileScreenTitle = styled(Title.MD)`
  margin: 0;
  padding: 0;
`;

const StyledDesktopScreenTitle = styled(Title.LG)`
  margin: 0;
  padding: 0;
`;
export const ScreenTitle = ({ children, ...props }: TextProps) => {
  const isDesktopOrTablet = useIsDesktopOrTablet();
  const HeaderTitle = isDesktopOrTablet ? StyledDesktopScreenTitle : StyledMobileScreenTitle;

  return (
    <HeaderTitle htmlTag='h1' {...props}>
      {children}
    </HeaderTitle>
  );
};

const SectionTitleText = styled(SM)`
  padding: 10px 20px;
  margin: 0;
`;

export const SectionTitle = ({ children, ...props }: TextProps) => {
  const isDesktopOrTablet = useIsDesktopOrTablet();

  return (
    <SectionTitleText centered={isDesktopOrTablet} htmlTag='h2' {...props}>
      {children}
    </SectionTitleText>
  );
};

export default Title;
